import { takeLatest } from "redux-saga/effects"

import {
  createHotelCategoryAction,
  getHotelCategoryDetailAction,
  getHotelCategoryListAction,
  getHotelListAction,
  deleteHotelCategoryAction,
  editHotelCategoryAction,
  addDynamicFieldsAction,
  getDynamicFieldsAction,
  getHotelSubCategoryAction,
  createHotelSubCategoryAction,
  getHotelNestedCategoryAction,
  createHotelNestedCategoryAction,
  getHotelNestedSubCategoryAction,
  createHotelNestedSubCategoryAction,
  editHotelNestedSubCategoryAction,
  deleteHotelNestedSubCategoryAction,
  getHotelServiceItemAction,
  deleteHotelServiceItemAction,
  createCategoryItemsAction,
  editCategoryItemsAction,
  getCategoryItemsAction,
  uploadImageAction,
  changeCategoryOrderAction
} from "../action/index"
import {
  addDynamicFields,
  createHotelCategory,
  deleteHotelCategory,
  editHotelCategory,
  getDynamicFields,
  getHotelCategoryDetail,
  getHotelCategoryList,
  getHotelList,
  getHotelSubCategory,
  createHotelSubCategory,
  getHotelNestedCategory,
  createHotelNestedCategory,
  getHotelNestedSubCategory,
  createHotelNestedSubCategory,
  editHotelNestedSubCategory,
  deleteHotelNestedSubCategory,
  getHotelServiceItem,
  deleteHotelServiceItem,
  createCategoryItems,
  editCategoryItems,
  getCategoryItems,
  uploadImage,
  changeCategoryOrder
} from "./user"

export default function* HotelActionWatcher() {
  yield takeLatest(getHotelListAction, getHotelList)
  yield takeLatest(getHotelCategoryListAction, getHotelCategoryList)
  yield takeLatest(createHotelCategoryAction, createHotelCategory)
  yield takeLatest(getHotelCategoryDetailAction, getHotelCategoryDetail)
  yield takeLatest(editHotelCategoryAction, editHotelCategory)
  yield takeLatest(deleteHotelCategoryAction, deleteHotelCategory)
  yield takeLatest(getDynamicFieldsAction, getDynamicFields)
  yield takeLatest(addDynamicFieldsAction, addDynamicFields)
  yield takeLatest(getHotelSubCategoryAction, getHotelSubCategory)
  yield takeLatest(createHotelSubCategoryAction, createHotelSubCategory)
  yield takeLatest(getHotelNestedCategoryAction, getHotelNestedCategory)
  yield takeLatest(createHotelNestedCategoryAction, createHotelNestedCategory)
  yield takeLatest(getHotelNestedSubCategoryAction, getHotelNestedSubCategory)
  yield takeLatest(createHotelNestedSubCategoryAction, createHotelNestedSubCategory)
  yield takeLatest(editHotelNestedSubCategoryAction, editHotelNestedSubCategory)
  yield takeLatest(deleteHotelNestedSubCategoryAction, deleteHotelNestedSubCategory)
  yield takeLatest(getHotelServiceItemAction, getHotelServiceItem)
  yield takeLatest(deleteHotelServiceItemAction, deleteHotelServiceItem)
  yield takeLatest(createCategoryItemsAction, createCategoryItems)
  yield takeLatest(editCategoryItemsAction, editCategoryItems)
  yield takeLatest(getCategoryItemsAction, getCategoryItems)
  yield takeLatest(uploadImageAction, uploadImage)
  yield takeLatest(changeCategoryOrderAction, changeCategoryOrder)
}
